import { defineComponent as l, useCssVars as u, computed as o, createBlock as p, openBlock as m, resolveDynamicComponent as f, normalizeProps as _, guardReactiveProps as d, unref as t } from "vue";
import { useBindCx as g } from "@scalar/use-hooks/useBindCx";
import { getIcon as v, getLogo as b } from "./utils/index.js";
import { variants as h } from "./variants.js";
const k = {}, A = /* @__PURE__ */ l({
  ...k,
  inheritAttrs: !1,
  __name: "ScalarIcon",
  props: {
    icon: {},
    logo: {},
    size: {},
    thickness: {},
    label: {}
  },
  setup(n) {
    u((r) => ({
      c07589c2: a.value
    }));
    const e = n, { cx: s } = g(), a = o(() => e.thickness ?? "2"), c = o(
      () => e.label ? { "aria-label": e.label } : {
        "aria-hidden": !0,
        role: "presentation"
      }
    ), i = o(() => {
      if (e.icon)
        return v(e.icon);
      if (e.logo)
        return b(e.logo);
    });
    return (r, x) => (m(), p(f(i.value), _(d({
      ...t(s)("scalar-icon", t(h)({ size: r.size })),
      ...c.value
    })), null, 16));
  }
});
export {
  A as default
};
